<template>
  <div
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="px-4 pr-1">
            <v-col 
              cols="12">
              <v-row>
                <v-col 
                  cols="12">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-card-text
                      class="d-flex align-center">
                      <v-avatar
                        tile
                        size="60">
                        <v-img 
                          alt="amanata" 
                          :src="require('@/assets/icon/statistik.png')"
                          class="ma-auto">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="white">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>

                      <div
                        class="ml-4 mb-1">
                        <div
                          class="title black--text"
                          style="font-weight: 600;">
                          Data Statistik
                        </div>

                        <div
                          class="body-2">
                          Periode Tahun {{ filter.year }} Bulan {{ months[getMonth].text }}
                        </div>
                      </div>

                      <v-spacer />

                      <div
                        class="d-flex align-center">
                        <div v-if="user.role === 'admin'">
                          <v-autocomplete
                            filled
                            rounded
                            dense
  
                            :color="set_color"
                            v-on:change="fetch()"
                            @click:clear="filter.unit_id = ''; fetch();"
                          
                            clearable
                            placeholder="Pilih Unit"
  
                            hide-details
  
                            :items="unit"
                            item-text="title"
                            item-value="id"
                            :item-color="set_color"
  
                            v-model="filter.unit_id"
                            class="mx-1"
                            style="border-radius: 10px;">
                          </v-autocomplete>
                        </div>

                        <div v-if="user.role === 'admin'">
                          <v-autocomplete
                            filled
                            rounded
                            dense
  
                            :color="set_color"
                            v-on:change="fetch()"
                            @click:clear="filter.asistensi = ''; fetch();"
                            clearable
                            placeholder="Pilih Asisten"
  
                            :items="asistensi"
                            :item-color="set_color"
  
                            hide-details
  
                            
  
                            v-model="filter.asistensi"
                            required
                            class="mx-1"
                            style="border-radius: 10px;">
                          </v-autocomplete>
                        </div>


                        <v-select
                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Pilih Tahun"

                          hide-details

                          :items="years"
                          :item-color="set_color"

                          v-model="filter.year"
                          style="border-radius: 10px; width: 120px;">
                        </v-select>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row 
                justify="center">
                <v-col cols="12" md="6">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    height="100%"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                      <v-card-text>
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Pagu Anggaran
                            </div>

                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Sampai bulan <strong>{{ months[getMonth].text }}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div>
                            <v-img 
                              width="60"
                              height="60"
                              alt="amanata" 
                              :src="require('@/assets/icon/budget.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="mt-7 pb-0">
                        <div
                          class="mb-4">
                          <div>
                            Murni
                          </div>

                          <div
                            class="text-h5 black--text"
                            style="font-weight: 500;">
                            {{ detail.pagu_anggaran | price }}
                          </div>
                        </div>

                        <div>
                          <div>
                            Perubahan
                          </div>

                          <div
                            class="text-h5 black--text"
                            style="font-weight: 500;">
                            {{ detail.pagu_anggaran_perubahan === null ? 0 : detail.pagu_anggaran_perubahan }}
                          </div>
                        </div>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>

                <v-col 
                  cols="12" 
                  md="6">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                      <v-card-text>
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Perkembangan Fisik 
                            </div>

                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Sampai bulan <strong>{{ months[getMonth].text }}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div>
                            <v-img 
                              width="60"
                              height="60"
                              alt="amanata" 
                              :src="require('@/assets/icon/dash_kegiatan.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="py-0">
                        <v-row>
                          <v-col>
                            <div style="font-size: 17px; font-weight: 600;" class="mb-3">
                              Target
                            </div>

                            <div>
                              <div
                                class="mb-4">
                                <div>
                                  Murni
                                </div>
                                
                                <div
                                  class="text-h5 black--text"
                                  style="font-weight: 500;">
                                  {{ detail.target_fisik === null ? 0 : detail.target_fisik}}
                                </div>
                              </div>
      
                              <div>
                                <div>
                                  Perubahan
                                </div>
                                <div
                                  class="text-h5 black--text"
                                  style="font-weight: 500;">
                                  0
                                </div>
                              </div>

                            </div>
                          </v-col>

                          <v-col>
                            <div style="font-size: 17px; font-weight: 600;" class="mb-3">
                              Realisasi
                            </div>

                            <div>
                              <div
                                class="mb-4">
                                <div>
                                  Murni
                                </div>
                                
                                <div
                                  class="text-h5 black--text"
                                  style="font-weight: 500;">
                                  {{ detail.realisasi_fisik === null ? 0 : detail.realisasi_fisik }}
                                </div>
                              </div>
      
                              <div>
                                <div>
                                  Perubahan
                                </div>
                                <div
                                  class="text-h5 black--text"
                                  style="font-weight: 500;">
                                  0
                                </div>
                              </div>

                            </div>
                          </v-col>

                          <v-col>
                            <div style="font-size: 17px; font-weight: 600;" class="mb-3">
                              Deviasi
                            </div>

                            <div>
                              <div
                                class="mb-4">
                                <div>
                                  Murni
                                </div>
                                
                                <div
                                  class="text-h5 black--text"
                                  style="font-weight: 500;">
                                  {{ detail.deviasi_fisik === null ? 0 : detail.deviasi_fisik }}
                                </div>
                              </div>
      
                              <div>
                                <div>
                                  Perubahan
                                </div>
                                <div
                                  class="text-h5 black--text"
                                  style="font-weight: 500;">
                                  0
                                </div>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col 
                  cols="12" 
                  md="6">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    height="100%"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="article, list-item-three-line, article, list-item-three-line">
                      <v-card-text>
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Anggaran Kas 
                            </div>

                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Sampai bulan <strong>{{ months[getMonth].text }}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div>
                            <v-img 
                              width="60"
                              height="60"
                              alt="amanata" 
                              :src="require('@/assets/icon/percent.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="pt-1">
                        <div
                          class="mb-4">
                          <div>
                            Murni
                          </div>
                          
                          <div
                            class="text-h5 black--text"
                            style="font-weight: 500;">
                            {{ detail.target_keuangan | price }}
                          </div>
                        </div>

                        <div>
                          <div>
                            Perubahan
                          </div>

                          <div
                            class="text-h5 black--text"
                            style="font-weight: 500;">
                            0
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text>
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Realisasi Keuangan/SP2D 
                            </div>
      
                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Sampai bulan <strong>{{ months[getMonth].text }}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>
      
                          <v-spacer />
                          
                        </div>
                      </v-card-text>
      
                      <v-card-text
                        class="pt-1">
                        <div
                          class="mb-4">
                          <div>
                            Murni
                          </div>
                          
                          <div
                            class="text-h5 black--text"
                            style="font-weight: 500;">
                            {{ detail.realisasi_keuangan === null ? 0 : detail.realisasi_keuangan}}
                          </div>
                        </div>
      
                        <div>
                          <div>
                            Perubahan
                          </div>

                          <div
                            class="text-h5 black--text"
                            style="font-weight: 500;">
                            0
                          </div>
                        </div>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>

                <v-col 
                  cols="12" 
                  md="6">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    height="216"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="article, list-item-three-line">
                      <v-card-text class="pb-0">
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Persentase SP2D Terhadap Pagu Anggaran 
                            </div>

                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Sampai bulan <strong>{{ months[getMonth].text }}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="mt-9">
                        <div
                          class="text-h5 black--text"
                          style="font-weight: 500;">
                          {{ detail.sp2d_anggaran }}
                        </div>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>

                  <v-card
                    class="border-radius mt-6"
                    color="#FFFFFF"
                    height="216"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="article, list-item-three-line">
                      <v-card-text class="pb-0">
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Persentase SP2D Terhadap Anggaran Kas
                            </div>

                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Sampai bulan <strong>{{ months[getMonth].text }}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="mt-9">
                        <div
                          class="text-h5 black--text"
                          style="font-weight: 500;">
                          {{ detail.sp2d_pagu_anggaran === null ? 0 : detail.sp2d_pagu_anggaran }}
                        </div>

                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col 
                  cols="12" 
                  md="12">
                  <v-card
                    class="border-radius mb-4"
                    color="#FFFFFF"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                      <v-card-text>
                        <div
                          class="d-flex align-center">
                          <div>
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Program, Kegiatan & Sub kegiatan 
                            </div>

                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Sampai bulan <strong>{{ months[getMonth].text }}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div>
                            <v-img 
                              width="60"
                              height="60"
                              alt="amanata" 
                              :src="require('@/assets/icon/percent.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>

                  <v-row>
                    <v-col>
                      <v-card
                        class="border-radius"
                        color="#FFFFFF"
                        style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                        <v-skeleton-loader
                          class="ma-auto"
                          :loading="process.load"
                          type="image">
                          <v-card-text>
                            <div
                              class="d-flex align-start">
                              <div>
                                <div 
                                  class="body-1 black--text"
                                  style="font-weight: 600; margin-bottom: 3px;">
                                  Program 
                                </div>

                                <div
                                  class="body-2"
                                  style="opacity: 70%;">
                                  Sampai bulan <strong>{{ months[getMonth].text }}</strong> tahun <strong>{{ filter.year }}</strong>
                                </div>
                              </div>

                              <v-spacer />

                              
                            </div>
                          </v-card-text>

                          <v-card-text
                            class="pt-0">
                            <div
                              class="mb-4">
                              <div>
                                Murni
                              </div>

                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                {{ detail.total_program }}
                              </div>
                            </div>

                            <div>
                              <div>
                                Perubahan
                              </div>

                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                0
                              </div>
                            </div>
                          </v-card-text>
                        </v-skeleton-loader>
                      </v-card>
                    </v-col>

                    <v-col>
                      <v-card
                        class="border-radius"
                        color="#FFFFFF"
                        style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                        <v-skeleton-loader
                          class="ma-auto"
                          :loading="process.load"
                          type="image">
                          <v-card-text>
                            <div
                              class="d-flex align-start">
                              <div>
                                <div 
                                  class="body-1 black--text"
                                  style="font-weight: 600; margin-bottom: 3px;">
                                  Kegiatan 
                                </div>

                                <div
                                  class="body-2"
                                  style="opacity: 70%;">
                                  Sampai bulan <strong>{{ months[getMonth].text }}</strong> tahun <strong>{{ filter.year }}</strong>
                                </div>
                              </div>

                              <v-spacer />
                              
                            </div>
                          </v-card-text>

                          <v-card-text
                            class="pt-0">
                            <div
                              class="mb-4">
                              <div>
                                Murni
                              </div>
                              
                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                {{ detail.total_kegiatan }}
                              </div>
                            </div>

                            <div>
                              <div>
                                Perubahan
                              </div>
                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                0
                              </div>
                            </div>
                          </v-card-text>
                        </v-skeleton-loader>
                      </v-card>
                    </v-col>

                    <v-col>
                      <v-card
                        class="border-radius"
                        color="#FFFFFF"
                        style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                        <v-skeleton-loader
                          class="ma-auto"
                          :loading="process.load"
                          type="image">
                          <v-card-text>
                            <div
                              class="d-flex align-start">
                              <div>
                                <div 
                                  class="body-1 black--text"
                                  style="font-weight: 600; margin-bottom: 3px;">
                                  Sub kegiatan 
                                </div>

                                <div
                                  class="body-2"
                                  style="opacity: 70%;">
                                  Sampai bulan <strong>{{ months[getMonth].text }}</strong> tahun <strong>{{ filter.year }}</strong>
                                </div>
                              </div>

                              <v-spacer />
                              
                            </div>
                          </v-card-text>

                          <v-card-text
                            class="pt-0">
                            <div
                              class="mb-4">
                              <div>
                                Murni
                              </div>

                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                {{ detail.total_sub_kegiatan }}
                              </div>
                            </div>

                            <div>
                              <div>
                                Perubahan
                              </div>

                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                0
                              </div>
                            </div>
                          </v-card-text>
                        </v-skeleton-loader>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        clock: {
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          time: ''
        },
        getMonth: new Date().getMonth(),

        asistensi: ['Asisten Administrasi Umum', 'Asisten Perekonomian dan Pembangunan', 'Asisten Pemerintahan dan Kesejahteraan Rakyat'],

        filter: {
          tahun_anggaran: new Date().getFullYear(),
          year: new Date().getFullYear(),
          month: 1,
          month_text: 'Januari',
          unit_id: '',
          asistensi: ''
        },
        bulan: [
          {
            text: 'Januari',
            value: 1
          },
          {
            text: 'Februari',
            value: 2
          },
          {
            text: 'Maret',
            value: 3
          },
          {
            text: 'April',
            value: 4
          },
          {
            text: 'Mei',
            value: 5
          },
          {
            text: 'Juni',
            value: 6
          },
          {
            text: 'Juli',
            value: 7
          },
          {
            text: 'Agustus',
            value: 8
          },
          {
            text: 'September',
            value: 9
          },
          {
            text: 'Oktober',
            value: 10
          },
          {
            text: 'November',
            value: 11
          },
          {
            text: 'Desember',
            value: 12
          }
        ],
        unit: [],
        detail: {},

        list: {
          data: [],
          summary: {},

          count: [
            {
              name: 'Total Anggaran',
              total: 0,
              icon: require('@/assets/icon/budget.png'),
              sub: []
            },
            {
              name: 'Realisasi Keuangan',
              total: 0,
              icon: require('@/assets/icon/dash_kegiatan.png'),
              sub: []
            },
            {
              name: 'Deviasi',
              total: 0,
              icon: require('@/assets/icon/percent.png'),
              sub: []
            },
            {
              name: 'Rata-Rata Target Fisik',
              total: 0,
              icon: require('@/assets/icon/average_target_fisik_format.png'),
              sub: []
            },
            {
              name: 'Persentase Anggaran SP2D',
              total: 0,
              icon: require('@/assets/icon/total_persentase_sp2d.png'),
              sub: []
            },
            {
              name: 'Persentase SP2D',
              total: 0,
              icon: require('@/assets/icon/total_persentase_sp2d_anggaran.png'),
              sub: []
            }
          ],

          program: [],

          persentase: {
            name: 'Persentase Pekerjaan',
            icon: require('@/assets/icon/dash_persen.png'),
            pie: {
              series: [44, 55, 13, 43, 22],
              chartOptions: {
                chart: {
                  width: 380,
                  type: 'pie',
                },
                labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
                responsive: [{
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 200
                    },
                    legend: {
                      position: 'bottom'
                    }
                  }
                }]
              }
            }
          }
        },
        
        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    watch: {
      'filter.year': function () {
        this.fetch()
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },

      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        this.filter.year = this.$store.state.year

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },
      months () {
        let numb = new Date().getMonth() + 1
        
        this.filter.month = numb

        this.filter.month_text = new Date().toLocaleString('id', { month: 'long' })

        return [
          {
            text: 'Januari',
            value: 1
          },
          {
            text: 'Februari',
            value: 2
          },
          {
            text: 'Maret',
            value: 3
          },
          {
            text: 'April',
            value: 4
          },
          {
            text: 'Mei',
            value: 5
          },
          {
            text: 'Juni',
            value: 6
          },
          {
            text: 'Juli',
            value: 7
          },
          {
            text: 'Agustus',
            value: 8
          },
          {
            text: 'September',
            value: 9
          },
          {
            text: 'Oktober',
            value: 10
          },
          {
            text: 'November',
            value: 11
          },
          {
            text: 'Desember',
            value: 12
          }
        ]
      }
    },
    mounted () {
      setInterval(this.updateTime, 1000)
      
      this.fetch()

      this.fetchUnit()
    },
    methods: {
      async fetchUnit () {
        let params = {
          limit: 100000
        }

        await get('admin/unit/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.unit = res.results.data
          }
        })
      },
      async fetch () {
        this.process.load = true

        let params = {
          unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? 0 : this.filter.unit_id,
          asisten: this.filter.asistensi,

          year: this.filter.year,
          month: this.filter.month
        }

        await get('admin/dashboard/data', { params })
        .then(response => {
          let res = response.data
            
          this.process.load = false

          if (res.status === 200) {
            
            let data = res.results

            this.list.data = data.data
            this.detail = data
          }
        })
      },

      updateTime () {
        let cd = new Date()

        this.clock.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2)
      },
      zeroPadding (num, digit) {
        let zero = ''

        for(let i = 0; i < digit; i++) {
          zero += '0'
        }
        return (zero + num).slice(-digit)
      }
    }
  }
</script>

<style>
  .grafik_loader .v-skeleton-loader {
    min-height: 350px !important;
  }

  .grafik_loader .v-skeleton-loader .v-skeleton-loader__image {
    height: 350px !important;
  }

  .text-center {
    background: white !important;
  }
</style>